module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/woods_30cd46.jpg";